module.exports = {"540233100":"下司马镇","540233101":"帕里镇","540233200":"下亚东乡","540233201":"堆纳乡","540233202":"上亚东乡","540233203":"吉汝乡","540233204":"康布乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/540233.json
// module id = 2504
// module chunks = 0